export class AppConfigViewModel {
  dataSources: {
    friendlyName: string;
    configuration: {
      healthlake?: {
        datastoreID: string;
        endpoint: string;
        awsSecretAccessKey?: string;
        awsAccessKeyID?: string;
        awsSessionToken?: string;
      };
    };
  }[];

  // [CurveBeam] - URI for validating DMP access token
  validateAccessTokenEndpoint: string;
  // [CurveBeam] ClientId for WebSocket connection
  clientId: string;
  // [CurveBeam] URI for WebSocket connection
  webSocketURL?: string;
  // [CurveBeam] URI for BMD pipeline API
  servicePipelineUrl?: string;
  // [CurveBeam] URI for AWS HealthImaging
  awsHealthImagingEndpoint?: string;
  // [CurveBeam] URI for DMP home page
  dmpHomeURL?: string;
  // [CurveBeam] List of allowed referrers for DICOM Viewer
  referrerWhitelist?: string[];
  // [CurveBeam] URI for fetching expiring AWS credentials
  fetchExpiringCredentialsURI?: string;
  // [CurveBeam] Application region
  region?: string;

  fromData(data: any): AppConfigViewModel {
    this.dataSources = data?.dataSources;
    this.validateAccessTokenEndpoint = data?.validateAccessTokenEndpoint;
    this.clientId = data?.clientId;
    this.webSocketURL = data?.webSocketURL;
    this.servicePipelineUrl = data?.servicePipelineUrl;
    this.awsHealthImagingEndpoint = data?.awsHealthImagingEndpoint;
    this.dmpHomeURL = data?.dmpHomeURL;
    this.referrerWhitelist = data?.referrerWhitelist;
    this.fetchExpiringCredentialsURI = data?.fetchExpiringCredentialsURI;
    this.region = data?.region;
    return this;
  }
}
